export default __webpack_public_path__ + "static/media/homeBijoux5.f7032142.jpg";